import { Avatar } from "ant-design-vue";
const { ...other } = Avatar;
const YwAvatar = {
	...other,
	name: "YwAvatar",
};

YwAvatar.install = function (Vue) {
	Vue.component(YwAvatar.name, Avatar);
};

export default YwAvatar;
